__turbopack_context__.v({
  "info": "SpaceInfo-module-scss-module__6xH9ta__info",
  "item": "SpaceInfo-module-scss-module__6xH9ta__item",
  "subtitle": "SpaceInfo-module-scss-module__6xH9ta__subtitle",
  "title": "SpaceInfo-module-scss-module__6xH9ta__title",
});
